<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="720px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Sistemos pranešimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <el-overlay-loading :loading="modalloading" />
            <v-row>
              <v-col cols="12">
                <h4>{{ item.vieta }}</h4>
              </v-col>
              <v-col cols="12" md="12" class="mb-2">
                <el-switch label="Aktyvus" v-model="item.sis_aktyvus" />
              </v-col>
              <v-col cols="12" md="5">
                <el-date-picker
                  label="Vaizdavimo data nuo"
                  v-model="item.sis_galioja_nuo_diena"
                />
              </v-col>
              <v-col cols="12" md="5">
                <el-time-picker
                  label="Vaizdavimo laikas nuo"
                  v-model="item.sis_galioja_nuo_laikas"
                />
              </v-col>
              <v-col cols="12" md="5">
                <el-date-picker
                  label="Vaizdavimo data iki"
                  v-model="item.sis_galioja_iki_diena"
                />
              </v-col>
              <v-col cols="12" md="5">
                <el-time-picker
                  label="Vaizdavimo laikas iki"
                  v-model="item.sis_galioja_iki_laikas"
                />
              </v-col>
              <v-col cols="12">
                <vue-editor
                  class="mb-3"
                  :editorToolbar="customToolbar"
                  v-model="item.sis_pranesimas"
                ></vue-editor>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()" :loading="modalloading">
          Atšaukti
        </el-button>
        <el-button primary @click.native="saveData()" :loading="modalloading">
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ModalSistemaInfo',
  props: {
    value: Boolean,
    readonly: Boolean,
    item: Object,
    grupe: String,
  },
  components: { VueEditor },
  data() {
    return {
      loading: true,
      modalDaiktas: {},
      modalloading: true,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isAprasymas() {
      return this.grupe === 'aprasymas'
    },
    modalTitle() {
      return this.isAprasymas ? 'Aprašymas' : 'Patartis (tooltip)'
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isNaujas() {
      return !(this.item.too_id > 0)
    },
    customToolbar() {
      return [
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['link', 'clean'],
      ]
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          return
        }
        this.modalloading = true
        this.$emit('savedData', this.item)
      })
    },
    closeModal() {
      this.modalloading = false
      this.showModal = false
    },
    submit() {
      //
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
